/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/* eslint-env browser */

// core-js
import 'core-js/stable/aggregate-error';
import 'core-js/stable/array';
import 'core-js/stable/global-this';
import 'core-js/stable/map';
import 'core-js/stable/math';
import 'core-js/stable/number';
import 'core-js/stable/object';
import 'core-js/stable/promise';
import 'core-js/stable/regexp';
import 'core-js/stable/set';
import 'core-js/stable/string';
import 'core-js/stable/symbol';
import 'core-js/stable/url';
import 'core-js/stable/url-search-params';
import 'core-js/stable/weak-map';
import 'core-js/stable/weak-set';

// Ostatní
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import 'geometry-polyfill';
import 'whatwg-fetch';

// Chromium < 31 neumí DOMParser.parseFromString parsovat typ text/html.
// Toto se používá pro načítání HTML souborů. Toho je využíváno v rámci
// např. ModernViewerController a PlaylistDeterministicController.
// Zdroj: https://gist.github.com/eligrey/1129031
(function (DOMParser) {
  'use strict';

  const DOMParserProto = DOMParser.prototype;
  const realParseFromString = DOMParserProto.parseFromString;

  // Firefox/Opera/IE throw errors on unsupported types
  try {
    // WebKit returns null on unsupported types
    if (new DOMParser().parseFromString('', 'text/html') !== null) {
      // text/html parsing is natively supported
      return;
    }
  } catch (ex) {}

  DOMParserProto.parseFromString = function (markup, type) {
    if (/^\s*text\/html\s*(?:;|$)/i.test(type)) {
      const doc = document.implementation.createHTMLDocument('');
      doc.documentElement.innerHTML = markup;
      return doc;
    }
    return realParseFromString.apply(this, markup, type);
  };
})(DOMParser);
